module.exports = __webpack_public_path__ + "static/media/comercial.87aafebb.svg";